// hooks/useUserRole.js
import { useMemo } from "react";
import { useAuth } from "../context/AuthContext";

function normalizeRoleString(currentUser) {
  if (!currentUser) return "";
  const raw = currentUser.role;
  if (typeof raw === "string") return raw.trim().toLowerCase();
  if (raw && typeof raw === "object" && raw.role != null) {
    return String(raw.role).trim().toLowerCase();
  }
  return "";
}

function resolveUserRoleKey(roleStr) {
  if (!roleStr) return "user";
  if (roleStr.includes("admin")) return "admin";
  if (roleStr.includes("scribe_fulltime") || roleStr.includes("fulltime")) return "scribe_fulltime";
  if (roleStr.includes("scribe_parttime") || roleStr.includes("parttime")) return "scribe_parttime";
  if (roleStr.includes("user")) return "user";
  return "user";
}

export const useUserRole = () => {
  const { currentUser } = useAuth();

  return useMemo(() => {
    const roleStr = normalizeRoleString(currentUser);
    const userRole = resolveUserRoleKey(roleStr);
    const isAdmin = userRole === "admin";
    const isScribeFullTime = userRole === "scribe_fulltime";
    const isScribePartTime = userRole === "scribe_parttime";
    const isScriber = isScribeFullTime || isScribePartTime;
    const isRegularUser = userRole === "user";
    const authed = !!currentUser;

    // All signed-in accounts can manage their own visit/session records (API enforces ownership)
    const canDeleteSessions = authed;
    const canEditSessions = authed;
    const canCreateSessions = authed;

    return {
      role: userRole,
      userRole,
      isAdmin,
      isScriber,
      isScribeFullTime,
      isScribePartTime,
      isFullTimeScribe: isScribeFullTime,
      isPartTimeScribe: isScribePartTime,
      isRegularUser,
      canDeleteSessions,
      canEditSessions,
      canCreateSessions,
      // Back-compat aliases used in some components
      isScribeFulltime: isScribeFullTime,
      isScribeParttime: isScribePartTime,
    };
  }, [currentUser]);
};
